import { render, staticRenderFns } from "./imgPreview.vue?vue&type=template&id=0e2ee514&"
import script from "./imgPreview.vue?vue&type=script&lang=js&"
export * from "./imgPreview.vue?vue&type=script&lang=js&"
import style0 from "./imgPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports